import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';
import { Typography } from '@mui/material';
import { Button } from '@mui/material';

import CustomModal from 'components/CustomModal';

export const StyledCustomModal = styled(CustomModal)({
  '& .MuiPaper-root': {
    borderRadius: 0,
  },
});

export const CheckListIconBox = styled('Box')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 25,
  minWidth: 25,
  marginRight: 7,
  borderRadius: 4,
});

export const BodyWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'topalert',
})(({ topalert }) => ({
  display: 'flex',
  height: `calc(100vh - ${topalert ? '146' : '97'}px)`,
  overflow: 'auto',
  position: 'relative',
}));
export const CollapseBtn = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})(({ collapsed }) => ({
  color: '#000000',
  position: 'absolute',
  zIndex: 222,
  top: '50%',
  transform: 'translateY(-50%)',
  right: collapsed ? 0 : '23%',
  background: 'white',
  height: 45,
  border: '1px solid #E0E0E0',
  borderRight: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: '0.4s ease all',
  borderRadius: '6px 0 0 6px',
  cursor: 'pointer',
  svg: {
    transition: '0.4s ease all',
    transform: collapsed ? 'rotate(180deg)' : 'rotate(0deg)',
  },
}));

export const BuilderBody = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'topalert',
})(({ theme, topalert }) => ({
  padding: '20px 20px 0px 20px',
  borderRight: '1px solid #E0E0E0',
  height: `calc(100vh - ${topalert ? '146' : '97'}px)`,
  overflow: 'auto',
  width: '77%',
  position: 'relative',
  transition: '0.4s ease all',
}));

export const EmulatorWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'topalert',
})(({ topalert }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  padding: '24px 16px',
  gap: '9px',
  width: '23%',
  height: `calc(100vh - ${topalert ? '146' : '98'}px)`,
  overflow: 'auto',
  transition: '0.4s ease all',
  '& .title': {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: '21.86px',
    color: '#212121',
  },
}));

export const AnnouncementEmulator = styled(Box)(({ theme }) => ({
  fontSize: 15,
  lineHeight: '20.49px',
  width: '100%',
  height: '100%',
  overflow: 'auto',
  '.noImgCnt': {
    width: '100%',
    height: 200,
    background: '#E4EAEC',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fontSize: '50px',
      color: '#90A4AE',
    },
  },
  '.infoCnt': {
    padding: 10,
    borderRadius: 6,
    marginTop: '-21px',
    position: 'relative',
    background: 'white',
  },
  '.imgCnt': {
    width: '100%',
    height: 200,
    background: '#E4EAEC',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
}));

export const TemplateNameEmulator = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: 15,
  lineHeight: '20.49px',
  whiteSpace: 'pre',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: '#000000',
}));

export const OpenOnMobileButton = styled(Button)(({ theme }) => ({
  borderRadius: 6,
  padding: '6px 16px',
  height: 36,
}));

export const LoaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const SaveChangesPrompt = styled(Box)({
  padding: '10px',

  '& .header': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '30px',
  },
  '& .title': {
    fontWeight: 800,
    fontSize: 22,
    lineHeight: '30.05px',
  },
  '& .description': {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '21.86px',
    color: 'rgba(0, 0, 0, 1)',
    marginBottom: '40px',
  },

  '& button': {
    borderRadius: '8px',
  },
});

export const CountBox = styled(Box)({
  padding: '10px',
  display: 'flex',
  alignItems: 'center',
  fontSize: '13px',
  fontWeight: '600',
  color: '#000000',
  border: '1px solid #E0E0E0',
  borderRadius: '12px',
  flex: 1,
  gap: 10,
  '& .icon': {
    background: '#E0F2F1',
    color: '#009688',
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    '& path': { fill: 'currentColor' },
  },
  '& .count': {
    fontSize: '18px',
    fontWeight: '700',
    lineHeight: '20px',
  },
  '& .Recipients': {
    fontWeight: 800,
    fontSize: 22,
    lineHeight: '30.05px',
  },
  '& .description': {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '21.86px',
    color: 'rgba(0, 0, 0, 1)',
    marginBottom: '40px',
  },

  '& button': {
    borderRadius: '8px',
  },
});
export const ScheduleIcon = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#6868FE',
  borderRadius: '50%',
  background: '#EBEAFF',
  width: 38,
  height: 38,
  marginTop: 10,
});

export const AttachmentsWrapper = styled(Box)({
  border: '1px solid #E0E0E0',
  borderRadius: '12px',
  marginBottom: '16px',
  padding: '16px',
  '& li': {
    padding: '4px',
  },
  '& .attachementItem+.attachementItem': {
    borderTop: '1px solid #E0E0E0',
  },
});
export const CoverCnt = styled(Box)({
  position: 'relative',
  display: 'block',
  marginBottom: 2,
  marginTop: '-36px',
  marginLeft: '-100px',
  width: 'calc(100% + 200px)',
  height: 200,
  '& .coverImage': {
    width: '100%',
    height: '100%',
    maxHeight: '200px',
    objectFit: 'cover',
  },
  '& .coverActions': {
    position: 'absolute',
    bottom: 20,
    right: 20,
    display: 'flex',
    alignItems: 'center',
    opacity: 0,
    '& button': {
      background: '#fff',
      padding: '8px 12px',
      fontSize: 14,
      width: 'auto',
      minWidth: 'auto',
    },
  },
  '&:hover': {
    '& .coverActions': {
      opacity: 1,
    },
  },
});
